import store from '../../store'
import http from '../../http'
import Mustache from 'mustache'
import { bus } from '../bus'

export const pdf = function () {
  const featureEnabled = true

  const templateDirPath = `${window.location.protocol}//${window.location.host}/templates/pdf/`
  const templateDirPublicPath = 'http://report.homesearch.local:5200/templates/pdf'
  /**
   * Render a letter from its name + data
   *
   * @param {string} template   Template name (e.g. template.html.mustache).
   * @param {object} [data={}]  Data to populate the template with.
   *
   * @returns {Promise<string>} Rendered template as text/html
   */
  const renderPDFTemplate = (template, data = {}) => {
    return http.get(`${templateDirPath}${template}`, { responseType: 'text' })
      .then(response => response.data)
      .then(template => {
        Mustache.parse(template)
        return Mustache.render(template, { header: data.header, path: templateDirPublicPath, body: data.body })
      })
  }

  /**
   * Generate a letter and send it to the API
   *
   * @param {object} data     Data to populate the template with.
   *
   * @returns {Promise<undefined>}
   */
  const generatePDFTemplate = function generatePDFTemplate (data) {
    bus.emit('loading')

    return renderPDFTemplate('template.html.mustache', data)
      .then(rendered => store.dispatch('pdf/sendPDF', {
        path: templateDirPath,
        data: rendered,
      }))
      .then(res => {
        if (res.status === 'success') {
          bus.emit('loaded')
        }
      })
      .catch(() => {
        bus.emit('loaded')
        bus.emit('showAlert', {
          msg: 'Something went wrong. Please try again. If this issue persists please contact us at hello@homesearch.co.uk',
          show: true,
          variant: 'danger',
          icon: 'times',
        })
      })
  }

  return {
    featureEnabled,
    renderPDFTemplate,
    generatePDFTemplate,
  }
}
